module.exports = __webpack_public_path__ + "static/media/mail.980fff66.png";